module.exports = [
	{
		"id": 2,
		"SteuerJahr": 1999,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 141624,
		"SteuerEinkommen_P25": 17.6,
		"SteuerEinkommen_Median": 34.5,
		"SteuerEinkommen_P75": 53.5,
		"eink_arm_Sum": 34801,
		"ant_eink_arm": 24.6,
		"p25": 100,
		"p50": 100,
		"p75": 100
	},
	{
		"id": 3,
		"SteuerJahr": 1999,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 58576,
		"SteuerEinkommen_P25": 44.2,
		"SteuerEinkommen_Median": 63.1,
		"SteuerEinkommen_P75": 89.5,
		"eink_arm_Sum": 7527,
		"ant_eink_arm": 12.8,
		"p25": 100,
		"p50": 100,
		"p75": 100
	},
	{
		"id": 1070,
		"SteuerJahr": 2000,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 143142,
		"SteuerEinkommen_P25": 18.5,
		"SteuerEinkommen_Median": 36,
		"SteuerEinkommen_P75": 55.8,
		"eink_arm_Sum": 35103,
		"ant_eink_arm": 24.5,
		"p25": 105.1136363636,
		"p50": 104.347826087,
		"p75": 104.2990654206
	},
	{
		"id": 1071,
		"SteuerJahr": 2000,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 57847,
		"SteuerEinkommen_P25": 46,
		"SteuerEinkommen_Median": 65.4,
		"SteuerEinkommen_P75": 93.4,
		"eink_arm_Sum": 7156,
		"ant_eink_arm": 12.4,
		"p25": 104.07239819,
		"p50": 103.6450079239,
		"p75": 104.3575418994
	},
	{
		"id": 2143,
		"SteuerJahr": 2001,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 145186,
		"SteuerEinkommen_P25": 19.4,
		"SteuerEinkommen_Median": 37.6,
		"SteuerEinkommen_P75": 58.3,
		"eink_arm_Sum": 35483,
		"ant_eink_arm": 24.4,
		"p25": 110.2272727273,
		"p50": 108.9855072464,
		"p75": 108.9719626168
	},
	{
		"id": 2144,
		"SteuerJahr": 2001,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 57571,
		"SteuerEinkommen_P25": 47.5,
		"SteuerEinkommen_Median": 67.6,
		"SteuerEinkommen_P75": 97.4,
		"eink_arm_Sum": 7159,
		"ant_eink_arm": 12.4,
		"p25": 107.4660633484,
		"p50": 107.1315372425,
		"p75": 108.8268156425
	},
	{
		"id": 3219,
		"SteuerJahr": 2002,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 146657,
		"SteuerEinkommen_P25": 19,
		"SteuerEinkommen_Median": 37.7,
		"SteuerEinkommen_P75": 58.4,
		"eink_arm_Sum": 36522,
		"ant_eink_arm": 24.9,
		"p25": 107.9545454545,
		"p50": 109.2753623188,
		"p75": 109.1588785047
	},
	{
		"id": 3220,
		"SteuerJahr": 2002,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 57099,
		"SteuerEinkommen_P25": 47.25,
		"SteuerEinkommen_Median": 67.5,
		"SteuerEinkommen_P75": 96.9,
		"eink_arm_Sum": 7197,
		"ant_eink_arm": 12.6,
		"p25": 106.9004524887,
		"p50": 106.9730586371,
		"p75": 108.2681564246
	},
	{
		"id": 4293,
		"SteuerJahr": 2003,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 147336,
		"SteuerEinkommen_P25": 18.9,
		"SteuerEinkommen_Median": 37.7,
		"SteuerEinkommen_P75": 58.3,
		"eink_arm_Sum": 36881,
		"ant_eink_arm": 25,
		"p25": 107.3863636364,
		"p50": 109.2753623188,
		"p75": 108.9719626168
	},
	{
		"id": 4294,
		"SteuerJahr": 2003,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 56473,
		"SteuerEinkommen_P25": 46.8,
		"SteuerEinkommen_Median": 67.3,
		"SteuerEinkommen_P75": 96.9,
		"eink_arm_Sum": 7197,
		"ant_eink_arm": 12.7,
		"p25": 105.8823529412,
		"p50": 106.6561014263,
		"p75": 108.2681564246
	},
	{
		"id": 5369,
		"SteuerJahr": 2004,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 147893,
		"SteuerEinkommen_P25": 18.3,
		"SteuerEinkommen_Median": 37.5,
		"SteuerEinkommen_P75": 58.5,
		"eink_arm_Sum": 37943,
		"ant_eink_arm": 25.7,
		"p25": 103.9772727273,
		"p50": 108.6956521739,
		"p75": 109.3457943925
	},
	{
		"id": 5370,
		"SteuerJahr": 2004,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 56015,
		"SteuerEinkommen_P25": 46.2,
		"SteuerEinkommen_Median": 67.1,
		"SteuerEinkommen_P75": 97.7,
		"eink_arm_Sum": 7597,
		"ant_eink_arm": 13.6,
		"p25": 104.5248868778,
		"p50": 106.3391442155,
		"p75": 109.1620111732
	},
	{
		"id": 6449,
		"SteuerJahr": 2005,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 149487,
		"SteuerEinkommen_P25": 18.3,
		"SteuerEinkommen_Median": 37.9,
		"SteuerEinkommen_P75": 59.7,
		"eink_arm_Sum": 38636,
		"ant_eink_arm": 25.8,
		"p25": 103.9772727273,
		"p50": 109.8550724638,
		"p75": 111.5887850467
	},
	{
		"id": 6450,
		"SteuerJahr": 2005,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 55657,
		"SteuerEinkommen_P25": 46.1,
		"SteuerEinkommen_Median": 67.7,
		"SteuerEinkommen_P75": 100,
		"eink_arm_Sum": 7838,
		"ant_eink_arm": 14.1,
		"p25": 104.2986425339,
		"p50": 107.2900158479,
		"p75": 111.7318435754
	},
	{
		"id": 7521,
		"SteuerJahr": 2006,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 151121,
		"SteuerEinkommen_P25": 18.8,
		"SteuerEinkommen_Median": 38.9,
		"SteuerEinkommen_P75": 61,
		"eink_arm_Sum": 39194,
		"ant_eink_arm": 25.9,
		"p25": 106.8181818182,
		"p50": 112.7536231884,
		"p75": 114.0186915888
	},
	{
		"id": 7522,
		"SteuerJahr": 2006,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 55576,
		"SteuerEinkommen_P25": 44.6,
		"SteuerEinkommen_Median": 67.1,
		"SteuerEinkommen_P75": 100.9,
		"eink_arm_Sum": 8467,
		"ant_eink_arm": 15.2,
		"p25": 100.9049773756,
		"p50": 106.3391442155,
		"p75": 112.7374301676
	},
	{
		"id": 8585,
		"SteuerJahr": 2007,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 154430,
		"SteuerEinkommen_P25": 19.9,
		"SteuerEinkommen_Median": 40.1,
		"SteuerEinkommen_P75": 63.3,
		"eink_arm_Sum": 40237,
		"ant_eink_arm": 26.1,
		"p25": 113.0681818182,
		"p50": 116.231884058,
		"p75": 118.3177570093
	},
	{
		"id": 8586,
		"SteuerJahr": 2007,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 55274,
		"SteuerEinkommen_P25": 46.3,
		"SteuerEinkommen_Median": 70,
		"SteuerEinkommen_P75": 105.4,
		"eink_arm_Sum": 8478,
		"ant_eink_arm": 15.3,
		"p25": 104.7511312217,
		"p50": 110.9350237718,
		"p75": 117.7653631285
	},
	{
		"id": 9642,
		"SteuerJahr": 2008,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 156260,
		"SteuerEinkommen_P25": 20,
		"SteuerEinkommen_Median": 41.7,
		"SteuerEinkommen_P75": 65.8,
		"eink_arm_Sum": 40695,
		"ant_eink_arm": 26,
		"p25": 113.6363636364,
		"p50": 120.8695652174,
		"p75": 122.9906542056
	},
	{
		"id": 9643,
		"SteuerJahr": 2008,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 55846,
		"SteuerEinkommen_P25": 47.6,
		"SteuerEinkommen_Median": 72.2,
		"SteuerEinkommen_P75": 110.7,
		"eink_arm_Sum": 8428,
		"ant_eink_arm": 15.1,
		"p25": 107.6923076923,
		"p50": 114.4215530903,
		"p75": 123.687150838
	},
	{
		"id": 10690,
		"SteuerJahr": 2009,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 157472,
		"SteuerEinkommen_P25": 20,
		"SteuerEinkommen_Median": 42,
		"SteuerEinkommen_P75": 66.4,
		"eink_arm_Sum": 41472,
		"ant_eink_arm": 26.3,
		"p25": 113.6363636364,
		"p50": 121.7391304348,
		"p75": 124.1121495327
	},
	{
		"id": 10691,
		"SteuerJahr": 2009,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 55756,
		"SteuerEinkommen_P25": 48.9,
		"SteuerEinkommen_Median": 74.2,
		"SteuerEinkommen_P75": 113.65,
		"eink_arm_Sum": 8492,
		"ant_eink_arm": 15.2,
		"p25": 110.6334841629,
		"p50": 117.5911251981,
		"p75": 126.9832402235
	},
	{
		"id": 11733,
		"SteuerJahr": 2010,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 158606,
		"SteuerEinkommen_P25": 20,
		"SteuerEinkommen_Median": 42.2,
		"SteuerEinkommen_P75": 66.8,
		"eink_arm_Sum": 41963,
		"ant_eink_arm": 26.5,
		"p25": 113.6363636364,
		"p50": 122.3188405797,
		"p75": 124.8598130841
	},
	{
		"id": 11734,
		"SteuerJahr": 2010,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 55676,
		"SteuerEinkommen_P25": 49.6,
		"SteuerEinkommen_Median": 75.4,
		"SteuerEinkommen_P75": 116.3,
		"eink_arm_Sum": 8620,
		"ant_eink_arm": 15.5,
		"p25": 112.2171945701,
		"p50": 119.4928684628,
		"p75": 129.9441340782
	},
	{
		"id": 12772,
		"SteuerJahr": 2011,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 159548,
		"SteuerEinkommen_P25": 20,
		"SteuerEinkommen_Median": 42.6,
		"SteuerEinkommen_P75": 67.6,
		"eink_arm_Sum": 42392,
		"ant_eink_arm": 26.6,
		"p25": 113.6363636364,
		"p50": 123.4782608696,
		"p75": 126.3551401869
	},
	{
		"id": 12773,
		"SteuerJahr": 2011,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 55775,
		"SteuerEinkommen_P25": 50,
		"SteuerEinkommen_Median": 76.6,
		"SteuerEinkommen_P75": 118.8,
		"eink_arm_Sum": 8788,
		"ant_eink_arm": 15.8,
		"p25": 113.1221719457,
		"p50": 121.3946117274,
		"p75": 132.7374301676
	},
	{
		"id": 13818,
		"SteuerJahr": 2012,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 161460,
		"SteuerEinkommen_P25": 20,
		"SteuerEinkommen_Median": 42.7,
		"SteuerEinkommen_P75": 68,
		"eink_arm_Sum": 43351,
		"ant_eink_arm": 26.8,
		"p25": 113.6363636364,
		"p50": 123.768115942,
		"p75": 127.1028037383
	},
	{
		"id": 13819,
		"SteuerJahr": 2012,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 55732,
		"SteuerEinkommen_P25": 49.4,
		"SteuerEinkommen_Median": 76.5,
		"SteuerEinkommen_P75": 119.2,
		"eink_arm_Sum": 9094,
		"ant_eink_arm": 16.3,
		"p25": 111.7647058824,
		"p50": 121.236133122,
		"p75": 133.1843575419
	},
	{
		"id": 14868,
		"SteuerJahr": 2013,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 163488,
		"SteuerEinkommen_P25": 20,
		"SteuerEinkommen_Median": 43,
		"SteuerEinkommen_P75": 68,
		"eink_arm_Sum": 44112,
		"ant_eink_arm": 27,
		"p25": 113.6363636364,
		"p50": 124.6376811594,
		"p75": 127.1028037383
	},
	{
		"id": 14869,
		"SteuerJahr": 2013,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 55700,
		"SteuerEinkommen_P25": 48.4,
		"SteuerEinkommen_Median": 76.2,
		"SteuerEinkommen_P75": 119.5,
		"eink_arm_Sum": 9570,
		"ant_eink_arm": 17.2,
		"p25": 109.5022624434,
		"p50": 120.7606973059,
		"p75": 133.5195530726
	},
	{
		"id": 15920,
		"SteuerJahr": 2014,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Grundtarif",
		"AnzBestZiv_sum": 159172,
		"SteuerEinkommen_P25": 19.6,
		"SteuerEinkommen_Median": 42.2,
		"SteuerEinkommen_P75": 66,
		"eink_arm_Sum": 43332,
		"ant_eink_arm": 27.2,
		"p25": 111.3636363636,
		"p50": 122.3188405797,
		"p75": 123.3644859813
	},
	{
		"id": 15921,
		"SteuerJahr": 2014,
		"KreisSort": "Total",
		"QuarSort": "Total",
		"SteuerTariflang": "Verheiratet",
		"AnzBestZiv_sum": 56562,
		"SteuerEinkommen_P25": 48.8,
		"SteuerEinkommen_Median": 76.5,
		"SteuerEinkommen_P75": 119,
		"eink_arm_Sum": 9536,
		"ant_eink_arm": 16.9,
		"p25": 110.407239819,
		"p50": 121.236133122,
		"p75": 132.9608938547
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/components/multipleLineChart/data/data.json
// module id = 256
// module chunks = 0